module.exports = __webpack_public_path__ + "static/img/86061A_1_R_20220728_LC.5aa5433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/86061A_1_R_20220728_LC.png
// module id = V4Hk
// module chunks = 0